import { Link } from 'react-router-dom';

export default function TickerBar({ items }: { items: { id: string; title: string }[] }) {
  const loop = [...items, ...items];
  return (
    <div className="marquee-wrap relative flex items-center gap-4 bg-foreground-950 text-background-100 overflow-hidden">
      <div className="hidden sm:flex items-center gap-2 px-4 md:px-6 py-3 bg-primary-500 text-background-50 shrink-0 z-10">
        <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
        <span className="text-xs font-medium whitespace-nowrap">热点滚动</span>
      </div>
      <div className="relative flex-1 overflow-hidden py-3">
        <div className="flex w-max animate-marquee">
          {loop.map((item, i) => (
            <Link
              key={`${item.id}-${i}`}
              to={`/article/${item.id}`}
              className="flex items-center gap-2 px-6 text-xs md:text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
              {item.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}